module.exports = __webpack_public_path__ + "img/squig4.09486fb.png";